import { render, staticRenderFns } from "./HeroVideo.vue?vue&type=template&id=27c4f700&scoped=true&"
import script from "./HeroVideo.vue?vue&type=script&lang=js&"
export * from "./HeroVideo.vue?vue&type=script&lang=js&"
import style0 from "./HeroVideo.vue?vue&type=style&index=0&id=27c4f700&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4f700",
  null
  
)

export default component.exports